export var DocsBlockItemVariantLayoutAlign;
(function (DocsBlockItemVariantLayoutAlign) {
    /** Vertically on top */
    DocsBlockItemVariantLayoutAlign["start"] = "Start";
    /** Vertically centered */
    DocsBlockItemVariantLayoutAlign["center"] = "Center";
    /** Vertically on the bottom */
    DocsBlockItemVariantLayoutAlign["end"] = "End";
})(DocsBlockItemVariantLayoutAlign || (DocsBlockItemVariantLayoutAlign = {}));
